import React from 'react';

import { CaseStudies, Heading } from '../../../components';



const CaseSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Case Studies'} subTitle={'Our Achievements'} />

      {/* Case Studies Section */}
      <CaseStudies />

    </section>

  );
}

export default CaseSection;